<template>
  <el-tooltip :content="content" placement="top" :disabled="disabled">
    <div class="template-text-conent" ref="template-text-conent">
      <span class="template-text" ref="template-text">
        {{ content || '' }}
      </span>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    content: { type: String, default: '' },
  },
  data() {
    return { disabled: false }
  },
  watch: {
    content() {
      this.loading()
    },
  },
  mounted() {
    this.loading()
  },
  methods: {
    loading() {
      const content = this.$refs['template-text-conent']
      const text = this.$refs['template-text']

      if (!content || !text) {
        setTimeout(() => {
          this.loading()
        }, 1000)
        return
      }

      const textWidth = text.offsetWidth
      const contentWidth = content.offsetWidth
      this.disabled = textWidth < contentWidth
    },
  },
}
</script>

<style lang="scss" scoped>
.template-text-conent {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
